import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from "./component/2/Button";
import Canvas from "./component/3/Canvas";
import Boom from "./component/Boom/Boom";





function App() {




  return (
    <div className="App">

        {/*<Button/>*/}
        {/*<Canvas/>*/}
        <Boom/>
    </div>
  );
}

export default App;
